module.exports = __webpack_public_path__ + "static/media/cod.2659ddac.svg";